import { Injectable } from '@angular/core';
import { Effect, Actions, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { Action, select, Store } from '@ngrx/store';
import {
  switchMap,
  map,
  catchError,
  filter,
  distinctUntilChanged,
} from 'rxjs/operators';

import {
  BrandInfoActionTypes,
  LoadBrandInfoContent,
  LoadBrandInfoContentSuccess,
  LoadBrandInfoContentFailure,
} from './brand-info.actions';
import * as fromRouter from '~core/store';
import { BrandPLPService } from '../../services/brand-plp.service';
import { BrandInfoState } from './brand-info.state';
import { ErrorResponse } from '~shared/models';
import { UrlUtils } from '~app/modules/generic/utils/url.utils';
import { APP_BRAND_PLP_ROUTE } from '~shared/constants';

@Injectable({
  providedIn: 'root',
})
export class BrandInfoEffects {
  private activeRoute$ = this.store.pipe(select(fromRouter.getRouterState));

  @Effect()
  loadBrandInfoContent$: Observable<Action> = this.actions$.pipe(
    ofType(BrandInfoActionTypes.LOAD_BRAND_INFO_CONTENT),
    switchMap((action: LoadBrandInfoContent) =>
      this.brandPlpService.getBrandInfo(action.payload).pipe(
        map(
          (response: BrandInfoState) =>
            new LoadBrandInfoContentSuccess({ response })
        ),
        catchError((error: ErrorResponse) =>
          of(new LoadBrandInfoContentFailure({ error }))
        )
      )
    )
  );

  @Effect()
  loadBrandInfoContentByRoute$: Observable<Action> = this.activeRoute$.pipe(
    filter((routeState) => {
      return !!routeState?.url
        ? routeState.url.includes(`/${APP_BRAND_PLP_ROUTE}/`)
        : false;
    }),
    map((routeState) => {
      const { url } = routeState;
      return UrlUtils.getSlugFromUrl(url);
    }),
    switchMap((brandSlug) => {
      return of(new LoadBrandInfoContent(brandSlug));
    })
  );

  constructor(
    private actions$: Actions,
    private brandPlpService: BrandPLPService,
    private store: Store<fromRouter.RouterState>
  ) {}
}
